import { useNavigate } from "react-router-dom";
import { clearAuthSession } from "./apiConfig";
import {
  LogOut,
  Search,
  Bell,
  UserRound,
  Menu,
} from "lucide-react";

function Topbar({
  title,
  subtitle,
  onMenuClick,
}) {
  const navigate = useNavigate();

  const user = JSON.parse(
    sessionStorage.getItem("user") || "{}"
  );

  const logout = () => {
    clearAuthSession();

    navigate("/login", {
      replace: true,
    });
  };

  return (
    <header className="topbar">
      <div className="topbar-left">
        <button
          type="button"
          className="mobile-menu-btn"
          onClick={onMenuClick}
          aria-label="Open mobile menu"
        >
          <Menu size={22} />
        </button>

        <div className="topbar-title">
          <h3>{title}</h3>

          <p>
            {subtitle ||
              "E-Billing Management System"}
          </p>
        </div>
      </div>

      <div className="topbar-actions">
        <div className="topbar-search">
          <Search size={17} />

          <input
            type="search"
            placeholder="Search bill, product..."
          />
        </div>

        <button
          type="button"
          className="topbar-icon-btn"
          aria-label="Notifications"
        >
          <Bell size={18} />
        </button>

        <div className="user-pill">
          <UserRound size={16} />

          <span>
            {user?.name || "User"}
          </span>
        </div>

        <button
          type="button"
          className="logout-btn"
          onClick={logout}
        >
          <LogOut size={16} />

          <span>Logout</span>
        </button>
      </div>
    </header>
  );
}

export default Topbar;